import React, { Component } from 'react';
import { AppRegistry } from 'react-native';

import JDReactMovie from './JDReactMovie/router';

import './JDReactMovie/common/web.css';

AppRegistry.registerComponent('JDReactMovie', () => JDReactMovie);

var app = document.getElementById('m_common_content');
if (!app) {
    app = document.createElement('div');
    document.body.appendChild(app);
}
AppRegistry.runApplication('JDReactMovie', {
    rootTag: app
});
